module.exports = __webpack_public_path__ + "static/img/wavm8s-013-arigto.6333106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-013-arigto.png
// module id = aPEV
// module chunks = 0